import { AddBoxOutlined } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { BenefitsTable, BodyText, CustomChip, SubTitleText } from "Application/components";
import { useBenefitsStore } from "Application/store";
import { FC } from "react";

interface BenefitsProps {
    addBenefitDialog: () => void;
}

export const Benefits: FC<BenefitsProps> = ({addBenefitDialog}) => {
    const { benefitsData } = useBenefitsStore();
    const benefitsCount = benefitsData.length;

    return (
        <Box className="border rounded-xl shadow-sm border-slate-200">
            <Box className="flex flex-wrap justify-between items-center p-6" id="header-section">
                <Box className="flex flex-col space-y-2" id="title-section">
                    <Box className="flex items-end space-x-2">
                        <SubTitleText text={'Benefits'} />
                        <CustomChip text={`${benefitsCount} entries`} />
                    </Box>
                    <BodyText text={'Manage the benefits associated with this product'} />
                </Box>
                <Button
                    onClick={addBenefitDialog}
                    className="text-sky-700 border-sky-200 bg-sky-50 rounded-md mt-2 md:mt-0"
                    variant="outlined"
                    startIcon={<AddBoxOutlined />}
                >
                    Add Benefits
                </Button>
            </Box>
            <BenefitsTable data={benefitsData} hasCheckboxSelection />
        </Box>
    )
}